<div class="bg cust-login-bg">
    <div class="container">
        <div class="row">
            <div class="col-md-6">
                <img src="assets/images/logo.png" alt="logo" class="company-logo">
                <h2 class="login-hd-main">Sign In</h2>
                <p class="login-line">Sign in to your account & <br>verify your documents.</p>
                <br>
                <p class="login-line">Contact Email <br> help@educred.co.in </p>
            </div>
            <div class="col-md-6">
                <div class="content-wrap">
                    <div class="col-md-12">
                        <div class="">
                            <div class="card-body">
                                <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                                    <div class="form-group">
                                        <h6 class="login-hd">Sign In</h6>
                                        <label for="username" class="form-label">Email Id</label>
                                        <input type="text" placeholder="Enter your Email Id" formControlName="username"
                                            class="form-control form-input" id="emailId" [pattern]="emailPattern"
                                            [ngClass]="{ 'is-invalid': submitted && f.username.invalid}" required
                                            emailId />
                                        <div *ngIf="submitted &&  f.username.invalid" class="invalid-feedback">
                                            <div *ngIf="f.username.errors.required">Email Id is required</div>
                                            <div *ngIf="f.username.errors.pattern">Email must be a valid email address
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label for="password" class="form-label">Password</label>
                                        <input type="password" placeholder="Enter your Password"
                                            formControlName="password" class="form-control form-input"
                                            [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
                                        <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                                            <div *ngIf="f.password.errors.required">Password is required</div>
                                        </div>
                                    </div>
                                    <a class="forgot-link color-theme" data-toggle="modal" data-target="#resetPasswordModal">Reset
                                        password?</a>
                                    <!-- <div class="pull-right">
                                        <a class="forgot-link">Terms and Condition</a>
                                    </div> -->

                                    <div class="col-md-9  col-md-offset-5 ">
                                        <label id="invalidError"
                                            style="color:#dc3545;font-size:100% ;">{{invalidError}}</label>
                                    </div>

                                    <button [disabled]="loading" class="btn bg-theme color-white form-btn">
                                        <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                                        Login
                                    </button>
                                    <p class="ortxt">or</p>
                                    <button [disabled]="loading" class="btn bg-theme color-white form-btn2"
                                        (click)="registerStudentPage()">
                                        <!-- <span *ngIfk="loading" class="spinner-border spinner-border-sm mr-1"></span> -->
                                        New Student Registration
                                    </button>
                                    <button [disabled]="loading" class="btn bg-theme color-white form-btn2 pull-right"
                                        (click)="registerEmployerPage()">
                                        <!-- <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span> -->
                                        New Third Party Registration
                                    </button>
                                    <!-- <div *ngIf="error" class="alert alert-danger mt-3 mb-0">{{error}}</div> -->

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="clear-both"></div>
<app-footer></app-footer>

<form [formGroup]="resetPasswordForm" (ngSubmit)="resetPassword(form)" #form="ngForm">
    <div class="modal fade" id="resetPasswordModal" tabindex="-1" role="dialog"
        aria-labelledby="resetPasswordModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header bg-theme">
                    <h5 class="modal-title" id="resetPasswordModalLabel">Reset Password</h5>
                    <button type="button" class="close" #closebutton data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <h3 class="reset-hd">Enter your registered email id and we will send a link for resetting
                                your password.</h3>
                            <div class="form-group input-group-lg">
                                <label for="regEmail" class="form-label">Your Registered Email Id</label>

                                <input type="email" placeholder="Enter your Registered Email Id"
                                    formControlName="regEmail" required class="form-control form-input" id="regEmail"
                                    [pattern]="emailPattern"
                                    [ngClass]="{ 'is-invalid': submittedReset && ff.regEmail.invalid }" />
                                <div *ngIf="submittedReset && ff.regEmail.invalid" class="invalid-feedback">
                                    <div *ngIf="ff.regEmail.errors.required">Email Id is required</div>
                                    <div *ngIf="ff.regEmail.errors.pattern">Email must be a valid email address</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-9  col-md-offset-5 ">
                        <label id="requiredEmail" style="color:#dc3545;font-size:100% ;">{{requiredEmail}}</label>
                    </div>
                    <div class="col-md-9  col-md-offset-5 ">
                        <label id="requiredEmail" style="color:#dc3545;font-size:100% ;">{{ErrorMessage}}</label>
                    </div>
                    <button class="approve-modal-btn bg-theme mr-auto">Submit</button>
                    <button class="reject-modal-btn mr-auto" data-dismiss="modal">Cancel</button>
                </div>
            </div>
        </div>
    </div>
</form>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="timer" [fullScreen]="true">
    <p style="color: white"> Loading... </p>
</ngx-spinner>



<ng-template #showModalBoxResetPassword class="modal fade " id="successModal" tabindex="-1" role="dialog" let-c="close"
let-d="dismiss" aria-labelledby="resetPasswordModalLabel" aria-hidden="false">

<div class="modal-content">
    <div class="modal-header success-modal-header">
        <h5 class="modal-title icon-title" id="resetPasswordModalLabel">
            <span class="icon-wrap"><img src="assets/images/thumb-up.png" class="fa-icon-modal" alt="img"></span>
            <!-- <i class="fa fa-check fa-icon-modal"
                aria-hidden="true"></i> -->
            </h5>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-md-12">
                <h3 class="success-text">Success</h3>
                <p class="reset-hd2">{{message}}</p>
            </div>
        </div>
        <button class="approve-modal-btn2 mr-auto" data-dismiss="modal" (click)="refresh()">Done</button>
    </div>
</div>

</ng-template>
